module.exports = __webpack_public_path__ + "assets/images/arrow_up_head.0d72d1e00270dee7162f2c64320a129d.svg";